import { render, staticRenderFns } from "./AddressOverview.vue?vue&type=template&id=310dbc42&scoped=true&"
import script from "./AddressOverview.vue?vue&type=script&lang=ts&"
export * from "./AddressOverview.vue?vue&type=script&lang=ts&"
import style0 from "./AddressOverview.vue?vue&type=style&index=0&id=310dbc42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310dbc42",
  null
  
)

export default component.exports